import React, { useCallback, useState, useMemo, useEffect } from 'react';
import ProductConfigurationContext from './ProductConfigurationContext';
import { useQuery } from '@apollo/react-hooks';
import ConfigPrice from './ConfigPrice.gql';
const ProductConfigurationProvider = ({ product, children }) => {
    const { configurations } = product;
    const [selectedConfigurations, setSelectedConfigurations] = useState({});
    const setConfigurations = useCallback((item) => {
        setSelectedConfigurations(prevState => (Object.assign(Object.assign({}, prevState), { [item.parent]: item })));
        return null;
    }, []);
    // Creating items structure to be used for PickerComponent/DropDown items
    const selectableOptionItems = useMemo(() => configurations
        ? configurations.map((config, index) => {
            const items = config.options.map(({ name, id }) => ({
                text: name,
                id,
                parent: config.name
            }));
            return { name: config.name, id: index, items: items };
        })
        : [], [configurations]);
    // Creating the variables for the product price query (with configs)
    const priceQueryVars = useMemo(() => {
        if (!selectedConfigurations || !product)
            return {};
        const optionIds = Object.keys(selectedConfigurations).map(key => selectedConfigurations.hasOwnProperty(key)
            ? { optionId: selectedConfigurations[key].id }
            : null);
        return { id: product.id, options: optionIds };
    }, [selectedConfigurations, product]);
    const priceQuery = useQuery(ConfigPrice, {
        variables: priceQueryVars
    });
    // useState is used instead of useMemo, therefor when the user picks another configuration option, the price is going to remain the same until the price query returns a value (otherwise it would be null during the query running time)
    const [configurationPrice, setConfigurationPrice] = useState(null);
    useEffect(() => {
        if (priceQuery.loading || priceQuery.error)
            return;
        if (priceQuery.data.product.configurationPrice)
            setConfigurationPrice(priceQuery.data.product.configurationPrice);
    }, [priceQuery]);
    const value = useMemo(() => ({
        configurations,
        selectedOptions: selectedConfigurations,
        setConfigurations,
        selectableOptionItems,
        configurationPrice,
        loading: priceQuery.loading
    }), [
        configurations,
        selectedConfigurations,
        setConfigurations,
        selectableOptionItems,
        configurationPrice,
        priceQuery.loading
    ]);
    return (React.createElement(ProductConfigurationContext.Provider, { value: value }, children));
};
const ConditionalProvider = ({ product, children }) => product.hasConfigurations ? (React.createElement(ProductConfigurationProvider, Object.assign({}, { product, children }))) : (React.createElement(React.Fragment, null, children));
export default ConditionalProvider;
//# sourceMappingURL=ProductConfigurationProvider.js.map